import TagPanel from './tag-panel.vue'
export default TagPanel



// WEBPACK FOOTER //
// ./src/components/tag-panel/index.js